import { render, staticRenderFns } from "./ExportBadgesPdf.vue?vue&type=template&id=032b6347"
import script from "./ExportBadgesPdf.vue?vue&type=script&lang=js"
export * from "./ExportBadgesPdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports